import { all, call } from 'redux-saga/effects';
import block from './block/blockSagas';
import objectstore from './objectstore/objectstoreSagas';

export default function* blockSaga() {
	yield all([call(block), call(objectstore)]);
}
